
import * as metahut_actions from './metahutActions';
import * as land_actions from './landActions';
import * as settings_actions from './SettingsAction';

let actions  = {...metahut_actions, ...land_actions, ...settings_actions};

export default actions;
